import { Button, Checkbox, IconButton, Menu, styled, Typography } from "@mui/material";
import { ColumnJustifyStartFlex, RoundedBlackBoundary, RowJustifyEndFlex, RowJustifySpaceBetweenFlex, RowJustifyStartFlex, StyledSelectField, StyledTextField } from "../Containers";
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from "react";
import _ from "lodash";
import { indigo } from "@mui/material/colors";

const FilterChip = styled(RoundedBlackBoundary)(({ theme }) => ({
    backgroundColor: indigo['50']
}));

export const TextFilter = ({ field, getValueHandler, valueHandler, deleteHandler, anchor }) => {

    const [editing, setEditing] = useState(true);
    const [chipAnchor, setChipAnchor] = useState();
    const [text, setText] = useState(() => getValueHandler());

    return (
        <>
            {editing &&
                <Menu open={editing} anchorEl={editing ? (chipAnchor ? chipAnchor : anchor) : null} onClose={() => {
                    setEditing(false);
                }}>
                    <RowJustifySpaceBetweenFlex gap={1} padding={1}>
                        <StyledTextField value={text} valueHandler={(value) => {
                            setText(value);
                        }} width={field.width ? field.width : '12ch'} />
                        <Button variant="outline-rounded-black" size="small" onClick={() => {
                            valueHandler && valueHandler(prev => [...prev ? prev.filter(e => e.key !== field.key) : [], { ...field, [field.key]: text }]);
                            setEditing(false);
                        }}>
                            Apply
                        </Button>
                    </RowJustifySpaceBetweenFlex>
                </Menu>}
            <FilterChip ref={setChipAnchor} >
                <Button variant="text-button" size="small" onClick={(e) => {
                    setChipAnchor(e.currentTarget);
                    setEditing(true);
                }}>
                    {field._name}:
                    <Typography variant="body2" fontWeight={'500'}>
                        {text}
                    </Typography>
                </Button>
                <IconButton size="small" onClick={() => deleteHandler && deleteHandler()}>
                    <ClearIcon fontSize="small" />
                </IconButton>
            </FilterChip>
        </>
    );
};

export const ChoiceFilter = ({ field, getValueHandler, valueHandler, deleteHandler, anchor }) => {

    const [editing, setEditing] = useState(true);
    const [chipAnchor, setChipAnchor] = useState();
    const [choice, setChoice] = useState(() => getValueHandler());

    return (
        <>
            {editing &&
                <Menu open={editing} anchorEl={editing ? (chipAnchor ? chipAnchor : anchor) : null} onClose={() => {
                    setEditing(false);
                }}>
                    <RowJustifySpaceBetweenFlex gap={1} padding={1}>
                        <StyledSelectField value={choice} valueHandler={setChoice} options={field.choices} />
                        <Button variant="outline-rounded-black" size="small" onClick={() => {
                            valueHandler && valueHandler(prev => [...prev ? prev.filter(e => e.key !== field.key) : [], { ...field, [field.key]: choice }]);
                            setEditing(false);
                        }}>
                            Apply
                        </Button>
                    </RowJustifySpaceBetweenFlex>
                </Menu>}
            <FilterChip ref={setChipAnchor} >
                <Button variant="text-button" size="small" onClick={(e) => {
                    setChipAnchor(e.currentTarget);
                    setEditing(true);
                }}>
                    {field._name}:
                    <Typography variant="body2" fontWeight={'500'}>
                        {field.choices.find(c => c.value === choice)?.name}
                    </Typography>
                </Button>
                <IconButton size="small" onClick={() => deleteHandler && deleteHandler()}>
                    <ClearIcon fontSize="small" />
                </IconButton>
            </FilterChip>
        </>
    );
};

export const CheckboxFilter = ({ field, getValueHandler, valueHandler, deleteHandler, anchor }) => {

    const [editing, setEditing] = useState(true);
    const [chipAnchor, setChipAnchor] = useState();
    const [checked, setChecked] = useState(() => getValueHandler());

    return (
        <>
            {editing &&
                <Menu open={editing} anchorEl={editing ? (chipAnchor ? chipAnchor : anchor) : null} onClose={() => {
                    setEditing(false);
                }}>
                    <RowJustifySpaceBetweenFlex gap={1} padding={1}>
                        <Checkbox checked={checked} onChange={(event) => setChecked(event.target.checked)} size="small" />
                        <Button variant="outline-rounded-black" size="small" onClick={() => {
                            valueHandler && valueHandler(prev => [...prev ? prev.filter(e => e.key !== field.key) : [], { ...field, [field.key]: checked }]);
                            setEditing(false);
                        }}>
                            Apply
                        </Button>
                    </RowJustifySpaceBetweenFlex>
                </Menu>}
            <FilterChip ref={setChipAnchor} >
                <Button variant="text-button" size="small" onClick={(e) => {
                    setChipAnchor(e.currentTarget);
                    setEditing(true);
                }}>
                    {field._name}:
                    <Checkbox variant="no-padding" disabled checked={checked} size="small" />
                </Button>
                <IconButton size="small" onClick={() => deleteHandler && deleteHandler()}>
                    <ClearIcon fontSize="small" />
                </IconButton>
            </FilterChip>
        </>
    );
};

export const FilterFactory = {
    text: TextFilter,
    choice: ChoiceFilter,
    checkbox: CheckboxFilter,
    number: '',
    multiselect: '',
    keywords: ''
};